module.exports = __webpack_public_path__ + "static/media/addToHomeScreenOption.ecffe21a.jpg";